import * as Yup from 'yup';

import type { YesNoBoolean, YesNoBooleanFormValue } from '@customTypes/form';

export const NullableStringValidator = Yup.string()
  .trim()
  .nullable()
  .transform(value => {
    if (value == null || value === '') {
      return null;
    }

    return value;
  });

export const YesNoBooleanValidator = () => Yup.string<YesNoBoolean>().oneOf(['YES', 'NO'], 'Please select an option');

export const OptionalYesNoBooleanValidator = () =>
  Yup.string<YesNoBooleanFormValue>().oneOf(['YES', 'NO', ''], 'Please select an option').default('').defined();
